/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScanStatisticsModel } from '../../models/scan-statistics-model';

export interface SystemDashboardScanStatisticsGet$Params {
  from?: string;
  to?: string;
  allRegions?: boolean;
  integratedSystemId?: string;
  organizationId?: string;
}

export function systemDashboardScanStatisticsGet(http: HttpClient, rootUrl: string, params?: SystemDashboardScanStatisticsGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<ScanStatisticsModel>> {
  const rb = new RequestBuilder(rootUrl, systemDashboardScanStatisticsGet.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('allRegions', params.allRegions, {});
    rb.query('integratedSystemId', params.integratedSystemId, {});
    rb.query('organizationId', params.organizationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<ScanStatisticsModel>;
    })
  );
}

systemDashboardScanStatisticsGet.PATH = '/SystemDashboard/ScanStatistics';
